<form #form (ngSubmit)="submitIfValid($event); $event.preventDefault(); $event.stopPropagation()">
  <ng-content></ng-content>
</form>
